import { PageController } from '@client/components/_core/layout/PageController';
import { LinkIncident } from '@client/components/incidents/LinkIncident';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/risk/register/details/$id/assessment/incidents')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Manage incidents',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <RiskIncidentManage />
        </PageController>
    );
}

function RiskIncidentManage() {
    const { id } = Route.useParams();

    return <LinkIncident entity="risk" entityId={id} urlKey="risk-incident-manage" />;
}
